<template>
  <div>
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      {{
        $store.state.redirectview == "PointManager" ? "เปลี่ยน" : "ลืม"
      }}รหัสผ่าน
    </div>
    <div class="mb-2">
      <v-btn @click="query.view = 'Login'" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="px-4 pt-2">
      <ValidationObserver ref="observer">
        <ValidationProvider
          vid="passwordconfirm"
          :rules="{
            required: true,
            min: 6,
          }"
          name="รหัสผ่าน"
          v-slot="{ errors }"
        >
          <div class="text-center" style="font-size: 20px">
            ตั้งค่ารหัสผ่านใหม่
          </div>
          <div>
            <v-text-field
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              :error-messages="errors"
              v-model="input.password"
              dense
              outlined
            ></v-text-field>
          </div>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
            min: 6,
            confirmed: 'passwordconfirm',
          }"
          name="ยืนยันรหัสผ่าน"
          v-slot="{ errors }"
        >
          <div class="text-center" style="font-size: 20px">
            กรอกรหัสผ่านอีกครั้ง
          </div>
          <div>
            <v-text-field
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              @click:append="show2 = !show2"
              :error-messages="errors"
              v-model="input.confirm_password"
              dense
              outlined
            ></v-text-field>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center">
        <v-btn :loading="saveloading" class="mt-2" @click="next" color="primary"
          >บันทึก</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      saveloading: false,
      show1: false,
      show2: false,
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
  },

  methods: {
    async next() {
      if (await this.$refs.observer.validate()) {
        var data = {
          memberId: this.input.memberId,
          password: this.input.password,
        };
        if (this.$store.state.redirectview == "PointManager") {
          data.memberId = this.$store.state.member.memberId;
        }
        this.saveloading = true;
        axios
          .put(this.serverUrl + "toacrm/change-password", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxxx",
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "เปลี่ยนรหัสผ่านสำเร็จ",
              });
              if (this.$store.state.redirectview == "PointManager") {
                this.query.view = this.$store.state.redirectview;
              } else {
                this.query.view = "Login";
              }
              // await this.$liff.closeWindow();
            } else if (response.data.responsecode == 204) {
              await this.$swal.fire({ text: response.data.reason });
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>